module.exports = __webpack_public_path__ + "d6d2aa9396f27e5955c5630d6b4b2c8e.MP3";